import { render, staticRenderFns } from "./CardPemeriksaan.vue?vue&type=template&id=7c039cae&scoped=true&"
import script from "./CardPemeriksaan.vue?vue&type=script&lang=ts&"
export * from "./CardPemeriksaan.vue?vue&type=script&lang=ts&"
import style0 from "./CardPemeriksaan.vue?vue&type=style&index=0&id=7c039cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c039cae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VDivider,VIcon,VSpacer})
